import { ReactComponent as SearchIcon } from 'assets/img/icon-search-black.svg';
import { components } from 'react-select';

const CountriesDropdownIndicatorTemplate = (props) => (
  <components.DropdownIndicator {...props}>
    <SearchIcon className="select__dropdown-icon" />
  </components.DropdownIndicator>
);
export default CountriesDropdownIndicatorTemplate;
